import { Button, Grid, TextField, MenuItem } from '@mui/material';
import { useFormik } from 'formik';
import {React, useEffect, useState} from 'react'
import * as yup from 'yup';
import TimezoneSelect from 'react-timezone-select'
import axios from "axios";
import { useUrlContext } from '../context/urlContext';

export default function PrinterLocationForm(props)
{
    const { UrlHelperObj } = useUrlContext();
    const [printMakeRecords,setPrintMakeRecords] = useState([]);
    const [deviceTypes, setDeviceTypes] = useState([]);
    const [selectedTimezone, setSelectedTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const [initialTimezone, setInitialTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const[isAddOperation,setIsAddOperation] = useState(false);

    function getTimezoneValue(timezone) {
        if (!timezone) return '';
        if (typeof timezone === 'string') return timezone;

        // react-timezone-select options are objects; be defensive for older/newer shapes.
        if (timezone.value) return timezone.value;
        if (timezone.timezone) return timezone.timezone;
        if (timezone.tzCode) return timezone.tzCode;
        if (timezone.abbrev) return timezone.abbrev;
        return '';
    }

    function handleTimezoneChange(timezone) {
        setSelectedTimezone(getTimezoneValue(timezone));
    }

    function normalizeDeviceTypeValue(deviceTypeValue) {
        const rawValue = String(deviceTypeValue ?? '');
        if (!rawValue) return '';

        const matched = deviceTypes.find((type) => {
            const typeId = String(type.id ?? '');
            const typeName = String(type.name ?? '');
            return rawValue === typeId || rawValue === typeName;
        });

        return matched?.name || rawValue;
    }
    
    useEffect(()=>{console.log(props)},[props]);
    const[recvValues,setRecvValues] = useState({ id:'', mac_id:'',
    location_id:props.LocationRow.id,
    printer_make_id:1,
    mode:'None',
    device_type:''
    });
    
    async function getPrintMakeRecords()
    {
        await axios.get(UrlHelperObj.printerMakeUrl())
        .then(response => response.data)
        .then(results => setPrintMakeRecords(results))
        .catch(err => console.log(err));
    }

    async function getDeviceTypes()
    {
        try {
            const response = await axios.get(UrlHelperObj.deviceTypesUrl());
            setDeviceTypes(response.data || []);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getDeviceTypes();
    }, []);
    useEffect(()=>{
        console.log(props)
        //getPrintMakeRecords();
       if(props.selectedRow !== null )//&& valueLoaded === false)
       {
            
            setRecvValues({
                id:props.selectedRow.id,
                mac_id:props.selectedRow.mac_id || props.selectedRow.mac || '',
                location_id:props.LocationRow.id,
                printer_make_id:props.printer_make_id,
                mode:props.selectedRow.mode || 'None',
                device_type:normalizeDeviceTypeValue(props.selectedRow.device_type)
            });
            const timezone = props.selectedRow.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
            setSelectedTimezone(timezone);
            setInitialTimezone(timezone);
            setIsAddOperation(false);
        }
        else
        {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            setRecvValues({  id:'',mac_id:'',
            location_id:props.LocationRow.id,
            printer_make_id:1,
            mode:'None',
            device_type:''
            });
            setSelectedTimezone(timezone);
            setInitialTimezone(timezone);
            setIsAddOperation(true);
          
        }

    },[props.selectedRow, deviceTypes]);
    
    const validationSchema = yup.object({
        mac_id: yup
            .string("AAA")
          .required('Mac Id is required'),
        
      });
      function onCancelForm()
      {
          //alert("Cancel");
          props.handleSubmit(null,isAddOperation,true)
      }
   
    
    const formik = useFormik({
        enableReinitialize:true,
        validateOnMount:true,
        validationSchema: validationSchema,
        initialValues:{
            id:recvValues?.id || '',
            mac_id:recvValues?.mac_id || '',
            location_id:props.LocationRow.id,
            printer_make_id:recvValues?.printer_make_id || 1,
            mode:recvValues?.mode || 'None',
            device_type:recvValues?.device_type || ''
        },
        onSubmit:(values)=>{
            const timezoneValue = getTimezoneValue(selectedTimezone) || Intl.DateTimeFormat().resolvedOptions().timeZone;
            values["timezone"] = timezoneValue;
            const selectedMode = props.mode || values.mode || 'None';
            values["mode"] = selectedMode;
            const accessMap = { 'None': 0, 'Auto': 1, 'Manual': 2 };
            values["access"] = accessMap[selectedMode] ?? 0;
            const selectedDeviceType = deviceTypes.find((type) => {
                const optionId = String(type.id ?? '');
                const optionName = String(type.name ?? '');
                const selectedValue = String(values.device_type ?? '');
                return selectedValue === optionId || selectedValue === optionName;
            });
            values["device_type"] = selectedDeviceType?.name || values.device_type;
            
            if(values.mac_id === '')
                props.handleSubmit(null,isAddOperation,true);
            else
            {
                props.handleSubmit(values,isAddOperation,false);
            }
        },
        // onReset:(values)=>{
        //     alert("Onreset");
        //     props.handleSubmit(null,isAddOperation,true)
        // }
    });

    const timezoneChanged = getTimezoneValue(selectedTimezone) !== getTimezoneValue(initialTimezone);
    const isSubmitDisabled = formik.isSubmitting || !formik.isValid || (!formik.dirty && !timezoneChanged);
    
    return(
        // <Grid style={{ borderStyle: 'solid', borderColor: 'pink' }} container item spacing={3} xs={12}
        // direction="column" alignItems='flex-start' >
            // <Paper >
            <form onSubmit={formik.handleSubmit} >
                {/* <Grid container spacing={2}> */}
                    <Grid item container xs={12} spacing={2}
                    justifyContent="flex-start" style={{ borderStyle: 'none', borderColor: 'black' }}
                    alignItems='flex-start' direction="row">
                {/* <Grid container spacing={{xs:2,md:5}} direction="row" columns={{xs:4,sm:8,md:12}}> */}
                            <Grid item xs={12} sm={12} md={12}  >
                            </Grid>
                            <Grid item  xs={12} sm={12} md={12}  >
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="mac_id"
                                    name="mac_id"
                                    label="Mac Id"
                                    value={formik.values.mac_id}
                                    onChange={formik.handleChange}
                                    error={formik.touched.mac_id && Boolean(formik.errors.mac_id)}
                                    helperText={formik.touched.mac_id && formik.errors.mac_id}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    select
                                    id="device_type"
                                    name="device_type"
                                    label="Device Type"
                                    value={formik.values.device_type}
                                    onChange={formik.handleChange}
                                >
                                    <MenuItem value="">Select Device Type</MenuItem>
                                    {deviceTypes && deviceTypes.map((type) => (
                                        <MenuItem value={type.name || ''} key={type.id || type.name}>
                                            {type.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                            <TimezoneSelect
                                value={selectedTimezone}
                                onChange={handleTimezoneChange}
                                />
                            </Grid>
                           {/*  <Grid  item xs={4} sm={4} md={4}  >
                                <TextField
                                variant='outlined'
                                fullWidth
                                select
                                id="printer_make_id"
                                name="printer_make_id"
                                label="Printer Make Id"
                                value={formik.values.printer_make_id}
                                onChange={formik.handleChange}//{(e) => handleChangeInPrinterMakeId(e)}
                                error={formik.touched.printer_make_id && Boolean(formik.errors.printer_make_id)}
                                helperText={formik.touched.printer_make_id && formik.errors.printer_make_id}
                                >
                                    {
                                        printMakeRecords && printMakeRecords.map(
                                            type => (
                                                <MenuItem value={type.id} key={type.id}>
                                                    {type.name}
                                                </MenuItem>
                                                )
                                        )
                                    }
                           
                                </TextField>
                                
                            </Grid>
                            */} 
                            
                            
                            
                            

                    </Grid>
                    <Grid container item xs={12}
                     direction="row" spacing={3}
                      style={{ borderStyle: 'none', borderColor: 'black' }} justifyContent='flex-start'>
                        <Grid item >
                            <Button
                                type='submit'
                                variant='contained'
                                disabled={isSubmitDisabled}
                                style={{
                                    backgroundColor: isSubmitDisabled ? '#bdbdbd' : 'blue',
                                    color: isSubmitDisabled ? '#616161' : '#ffffff',
                                    opacity: 1,
                                    boxShadow: isSubmitDisabled ? 'none' : undefined,
                                    cursor: isSubmitDisabled ? 'not-allowed' : undefined
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button type='button' onClick={onCancelForm}  color='secondary' variant='contained'>Cancel</Button>
                        </Grid>
                    </Grid>
                {/* </Grid> */}
            </form>
            // </Paper>
        // </Grid>


    );
}